var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSgfSoilRockSounding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,24c6.617,0,12-5.383,12-12S18.617,0,12,0C5.383,0,0,5.383,0,12s5.383,12,12,12Zm0-2c-5.514,0-10-4.486-10-10h20c0,5.514-4.486,10-10,10Z",
    fill: "#1c1c1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSgfSoilRockSounding1);
export default __webpack_public_path__ + "static/media/icon-sgf-soil-rock-sounding1.70e950b119de6013ee617e485c339651.svg";
export { ForwardRef as ReactComponent };